const specificProviders = [
    'yahoo',
    'icloud',
    'google',
    'aol',
    'gmx',
    'web'
]

export default {

    isSpecificProvider: function (provider) {
        return specificProviders.includes(provider ? provider.toLowerCase() : '')
    }

}
